import Tabs from '@eduzz/houston-ui/Tabs';
import { Fade } from '@material-ui/core';
import Button from '@material-ui/core/Button';
import Grid from '@material-ui/core/Grid';
import type { StyledComponentProps } from '@material-ui/core/styles';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { listUsers } from 'store/Orbita/AccessPolicy/actions';
import { Groups } from 'v2/components/Pages/AccessControl/Groups';
import accessControlService from 'v2/services/access-control';

import type { Group, User } from 'v2/interfaces/access-control';

import FormGroup from './components/FormGroup';
import FormUser from './components/FormUser';
import Users from './components/Users';

import type { DispatchProp } from 'react-redux';

interface IProps extends StyledComponentProps, DispatchProp<any> {
  listUsers: typeof listUsers;
}

interface IState {
  tab: number;
  openFormUser: boolean;
  openFormGroup: boolean;

  currentGroup?: Group;
  currentUser?: User;
}

class AccessPolicy extends Component<IProps, IState> {
  group = {
    openCreate: () => {
      this.setState({ openFormGroup: true, currentGroup: null });
    },
    openEdit: (currentGroup: Group) => {
      this.setState({ openFormGroup: true, currentGroup });
    },
    onComplete: () => {
      this.setState({ openFormGroup: false, currentGroup: null });

      setTimeout(() => {
        accessControlService.loadGroups().subscribe();
      }, 1000);
    },
    onCancel: () => {
      this.setState({
        openFormGroup: false,
        currentGroup: null,
      });
    },
  };

  user = {
    openCreate: () => {
      this.setState({ openFormUser: true, currentUser: null });
    },
    openEdit: (currentUser: User) => {
      this.setState({ openFormUser: true, currentUser });
    },
    onComplete: () => {
      this.setState({ openFormUser: false, currentUser: null });

      setTimeout(() => {
        this.props.listUsers();
      }, 1000);
    },
    onCancel: () => {
      this.setState({
        openFormUser: false,
        currentUser: null,
      });
    },
  };

  constructor(props: IProps) {
    super(props);
    this.state = { tab: 0, openFormUser: false, openFormGroup: false };
  }

  onTabChange = (tab: number) => {
    this.setState({ tab });
  };

  render() {
    const { tab, openFormGroup, openFormUser, currentGroup, currentUser } = this.state;

    return (
      <>
        {openFormGroup && <FormGroup current={currentGroup} onComplete={this.group.onComplete} onCancel={this.group.onCancel} />}

        {openFormUser && <FormUser current={currentUser} onComplete={this.user.onComplete} onCancel={this.user.onCancel} />}

        <Fade in timeout={500}>
          <div>
            <Grid container justify='space-between' alignItems='center' spacing={2}>
              <Grid item xs={12} sm={12} md={true}>
                <div className='my-title'>
                  <h1>Controle de Acesso</h1>
                  <p>Adicione um gerente para administrar algumas funções administrativas dos seus produtos, afiliados e campanha.</p>
                </div>
              </Grid>

              <Grid item xs={12} sm={6} md='auto'>
                <Button fullWidth variant='outlined' color='primary' onClick={this.group.openCreate}>
                  Adicionar Grupo
                </Button>
              </Grid>

              <Grid item xs={12} sm={6} md='auto'>
                <Button fullWidth variant='contained' color='primary' onClick={this.user.openCreate}>
                  Adicionar Usuário
                </Button>
              </Grid>
            </Grid>

            <div className='m24'></div>

            <Grid container>
              <Grid item xs={12}>
                <Tabs value={tab} onChange={this.onTabChange} style={{ paddingBottom: 16 }}>
                  <Tabs.Tab label={'Grupos'}>
                    <Groups onEdit={this.group.openEdit} />
                  </Tabs.Tab>
                  <Tabs.Tab label={'Usuários'}>
                    <Users onEdit={this.user.openEdit} />
                  </Tabs.Tab>
                </Tabs>
              </Grid>
            </Grid>
          </div>
        </Fade>
      </>
    );
  }
}

export default connect(null, {
  listUsers,
})(AccessPolicy);
